import React from 'react'
import styled from 'styled-components'

export const Opacity = styled.span`
  color: ${({ theme }) => theme.colors.text.dark.tertiary};
  margin-left: 12px;
  font-size: 0.8125rem;
`

const OpacityPercentage = ({ value: opacity }: { value?: number }) =>
  (opacity && opacity < 1) || opacity === 0 ? (
    <Opacity>{`${(opacity * 100).toFixed()}%`}</Opacity>
  ) : null

export default OpacityPercentage
